module.exports = __webpack_public_path__ + "img/protect-whitelabel.03c74676.png";